import { useSelector } from 'react-redux';

const useAuth = () => {
  const { user, token } = useSelector((state) => state.auth);
  // Check Redux state first, then localStorage
  const localToken = token || localStorage.getItem('jwt');
  return { user, token: localToken, isAuthenticated: !!localToken };
};

export default useAuth;
